import { checkAccess } from '../utils/permissionChecks';

export const permissionPolicies = {
  checkAccess: ({ currentUserRole, currentUserId, assignedTo }) =>
    checkAccess(currentUserRole, assignedTo, currentUserId)
};
